/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig } from  '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface INotificationManagementClient {
    /**
     * @return Success
     */
    getNotificationsReceipientTypes(): Promise<NotificationLookupsResponse>;
    /**
     * @return Success
     */
    getNotificationsStatuses(): Promise<NotificationLookupsResponse>;
    /**
     * @return Success
     */
    getNotificationsChannels(): Promise<NotificationLookupsResponse>;
    /**
     * @return Success
     */
    getNotificationsLanguages(): Promise<NotificationLookupsResponse>;
    /**
     * @return Success
     */
    getNotificationsTypes(): Promise<NotificationLookupsResponse>;
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param channel (optional) 
     * @param notificationId (optional) 
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     * @return Success
     */
    getTaxpyerNotifications(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, type?: NotificationTypes | undefined, status?: NotificationStatuses | undefined, channel?: NotificationChannels | undefined, notificationId?: number | null | undefined, pageSize?: number | undefined, pageNo?: number | undefined): Promise<SearchNotificationResponse>;
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param channel (optional) 
     * @param notificationId (optional) 
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     * @return Success
     */
    getNotificationsOfMy(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, type?: NotificationTypes | undefined, status?: NotificationStatuses | undefined, channel?: NotificationChannels | undefined, notificationId?: number | null | undefined, pageSize?: number | undefined, pageNo?: number | undefined): Promise<SearchNotificationResponse>;
    /**
     * @return Success
     */
    getNotificationById(id: number): Promise<ViewNotificationDetailsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveRecipientPreferenceMy(body?: RecipientPreferenceRequestDto | undefined): Promise<number>;
    /**
     * @param installationId (optional) 
     * @return Success
     */
    getUserNotificationpreferences(installationId?: string | null | undefined): Promise<GetUserPreferenceResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveRecipientPreferenceTaxpayer(body?: RecipientPreferenceRequestDto | undefined): Promise<number>;
    /**
     * @return Success
     */
    getTaxpayerNotificationpreferences(): Promise<GetUserPreferenceResponse>;
    /**
     * @return Success
     */
    getEmployeeLastCheckDate(): Promise<GetEmployeeLastCheckDateResponseDto>;
    /**
     * @param lastCheckDate (optional) 
     * @return Success
     */
    setEmployeeLastCheckDate(lastCheckDate?: Date | undefined): Promise<boolean>;
    /**
     * @return Success
     */
    hasNewNotifications(): Promise<boolean>;
    /**
     * @param type (optional) 
     * @return Success
     */
    getSystemConfiguration(type?: string | null | undefined): Promise<GetSystemConfigurationResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    activatePushNotification(body?: ActivatePushNotificationRequestDto | undefined): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deactivatePushNotification(body?: DeactivatePushNotificationRequestDto | undefined): Promise<boolean>;
}

export class NotificationManagementClient extends BaseClientApi implements INotificationManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @return Success
     */
    getNotificationsReceipientTypes(  cancelToken?: CancelToken | undefined): Promise<NotificationLookupsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/ReceipientTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsReceipientTypes(_response);
        });
    }

    protected processGetNotificationsReceipientTypes(response: AxiosResponse): Promise<NotificationLookupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationLookupsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationLookupsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationsStatuses(  cancelToken?: CancelToken | undefined): Promise<NotificationLookupsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsStatuses(_response);
        });
    }

    protected processGetNotificationsStatuses(response: AxiosResponse): Promise<NotificationLookupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationLookupsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationLookupsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationsChannels(  cancelToken?: CancelToken | undefined): Promise<NotificationLookupsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/channels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsChannels(_response);
        });
    }

    protected processGetNotificationsChannels(response: AxiosResponse): Promise<NotificationLookupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationLookupsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationLookupsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationsLanguages(  cancelToken?: CancelToken | undefined): Promise<NotificationLookupsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsLanguages(_response);
        });
    }

    protected processGetNotificationsLanguages(response: AxiosResponse): Promise<NotificationLookupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationLookupsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationLookupsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationsTypes(  cancelToken?: CancelToken | undefined): Promise<NotificationLookupsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsTypes(_response);
        });
    }

    protected processGetNotificationsTypes(response: AxiosResponse): Promise<NotificationLookupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationLookupsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationLookupsResponse>(<any>null);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param channel (optional) 
     * @param notificationId (optional) 
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     * @return Success
     */
    getTaxpyerNotifications(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, type?: NotificationTypes | undefined, status?: NotificationStatuses | undefined, channel?: NotificationChannels | undefined, notificationId?: number | null | undefined, pageSize?: number | undefined, pageNo?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SearchNotificationResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/taxpayer?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        if (notificationId !== undefined && notificationId !== null)
            url_ += "NotificationId=" + encodeURIComponent("" + notificationId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "PageNo=" + encodeURIComponent("" + pageNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxpyerNotifications(_response);
        });
    }

    protected processGetTaxpyerNotifications(response: AxiosResponse): Promise<SearchNotificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchNotificationResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchNotificationResponse>(<any>null);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param channel (optional) 
     * @param notificationId (optional) 
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     * @return Success
     */
    getNotificationsOfMy(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined, type?: NotificationTypes | undefined, status?: NotificationStatuses | undefined, channel?: NotificationChannels | undefined, notificationId?: number | null | undefined, pageSize?: number | undefined, pageNo?: number | undefined , cancelToken?: CancelToken | undefined): Promise<SearchNotificationResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/my?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "Channel=" + encodeURIComponent("" + channel) + "&";
        if (notificationId !== undefined && notificationId !== null)
            url_ += "NotificationId=" + encodeURIComponent("" + notificationId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "PageNo=" + encodeURIComponent("" + pageNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationsOfMy(_response);
        });
    }

    protected processGetNotificationsOfMy(response: AxiosResponse): Promise<SearchNotificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchNotificationResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchNotificationResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationById(id: number , cancelToken?: CancelToken | undefined): Promise<ViewNotificationDetailsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationById(_response);
        });
    }

    protected processGetNotificationById(response: AxiosResponse): Promise<ViewNotificationDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewNotificationDetailsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewNotificationDetailsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRecipientPreferenceMy(body?: RecipientPreferenceRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/my";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRecipientPreferenceMy(_response);
        });
    }

    protected processSaveRecipientPreferenceMy(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @param installationId (optional) 
     * @return Success
     */
    getUserNotificationpreferences(installationId?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserPreferenceResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/my?";
        if (installationId !== undefined && installationId !== null)
            url_ += "installationId=" + encodeURIComponent("" + installationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserNotificationpreferences(_response);
        });
    }

    protected processGetUserNotificationpreferences(response: AxiosResponse): Promise<GetUserPreferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserPreferenceResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserPreferenceResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRecipientPreferenceTaxpayer(body?: RecipientPreferenceRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/taxpayer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRecipientPreferenceTaxpayer(_response);
        });
    }

    protected processSaveRecipientPreferenceTaxpayer(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    getTaxpayerNotificationpreferences(  cancelToken?: CancelToken | undefined): Promise<GetUserPreferenceResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/taxpayer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxpayerNotificationpreferences(_response);
        });
    }

    protected processGetTaxpayerNotificationpreferences(response: AxiosResponse): Promise<GetUserPreferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserPreferenceResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserPreferenceResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getEmployeeLastCheckDate(  cancelToken?: CancelToken | undefined): Promise<GetEmployeeLastCheckDateResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/my/lastcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeLastCheckDate(_response);
        });
    }

    protected processGetEmployeeLastCheckDate(response: AxiosResponse): Promise<GetEmployeeLastCheckDateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeLastCheckDateResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeLastCheckDateResponseDto>(<any>null);
    }

    /**
     * @param lastCheckDate (optional) 
     * @return Success
     */
    setEmployeeLastCheckDate(lastCheckDate?: Date | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/my/lastcheck?";
        if (lastCheckDate === null)
            throw new Error("The parameter 'lastCheckDate' cannot be null.");
        else if (lastCheckDate !== undefined)
            url_ += "LastCheckDate=" + encodeURIComponent(lastCheckDate ? "" + lastCheckDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEmployeeLastCheckDate(_response);
        });
    }

    protected processSetEmployeeLastCheckDate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    hasNewNotifications(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/my/hasnewnotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasNewNotifications(_response);
        });
    }

    protected processHasNewNotifications(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getSystemConfiguration(type?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetSystemConfigurationResponse> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/preferences/getSystemConfiguration?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSystemConfiguration(_response);
        });
    }

    protected processGetSystemConfiguration(response: AxiosResponse): Promise<GetSystemConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSystemConfigurationResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSystemConfigurationResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activatePushNotification(body?: ActivatePushNotificationRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/push/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivatePushNotification(_response);
        });
    }

    protected processActivatePushNotification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deactivatePushNotification(body?: DeactivatePushNotificationRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/notifications/push/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivatePushNotification(_response);
        });
    }

    protected processDeactivatePushNotification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class NotificationLookupResultDto implements INotificationLookupResultDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: INotificationLookupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): NotificationLookupResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationLookupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data; 
    }

    clone(): NotificationLookupResultDto {
        const json = this.toJSON();
        let result = new NotificationLookupResultDto();
        result.init(json);
        return result;
    }
}

export interface INotificationLookupResultDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export class NotificationLookupsResponse implements INotificationLookupsResponse {
    lookups?: NotificationLookupResultDto[] | undefined;

    constructor(data?: INotificationLookupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lookups"])) {
                this.lookups = [] as any;
                for (let item of _data["lookups"])
                    this.lookups!.push(NotificationLookupResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationLookupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationLookupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lookups)) {
            data["lookups"] = [];
            for (let item of this.lookups)
                data["lookups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NotificationLookupsResponse {
        const json = this.toJSON();
        let result = new NotificationLookupsResponse();
        result.init(json);
        return result;
    }
}

export interface INotificationLookupsResponse {
    lookups?: NotificationLookupResultDto[] | undefined;
}

export enum NotificationTypes {
    None = "None",
    DelegationInvite = "DelegationInvite",
    OTP = "OTP",
    ProfileDataValidation = "ProfileDataValidation",
    GenericNotification = "GenericNotification",
    ReceiveDownloadReady = "ReceiveDownloadReady",
    DocumentReceived = "DocumentReceived",
    DocumentValidated = "DocumentValidated",
    DocumentCancelled = "DocumentCancelled",
    DocumentRejected = "DocumentRejected",
    UserProfileChanged = "UserProfileChanged",
    TaxpayerProfileChanged = "TaxpayerProfileChanged",
    IntermediaryContactDataValidation = "IntermediaryContactDataValidation",
    DocumentProcessAlertResult = "DocumentProcessAlertResult",
    DocumentCancellationInitiated = "DocumentCancellationInitiated",
    DocumentRejectionInitiated = "DocumentRejectionInitiated",
    DocumentCancellationDeclined = "DocumentCancellationDeclined",
    DocumentRejectionDeclined = "DocumentRejectionDeclined",
    CodeUsageApproved = "CodeUsageApproved",
    CodeUsageRejected = "CodeUsageRejected",
    CodeToApprove = "CodeToApprove",
    PosDataValidation = "PosDataValidation",
    ReceiptValidated = "ReceiptValidated",
    ReceiptProcessResult = "ReceiptProcessResult",
    ReceiptReceived = "ReceiptReceived",
    ReceiptSummary = "ReceiptSummary",
    ERPDataValidation = "ERPDataValidation",
    ReceiptPackageDownloadReady = "ReceiptPackageDownloadReady",
}

export enum NotificationStatuses {
    None = "None",
    New = "New",
    Pending = "Pending",
    Batched = "Batched",
    Delivered = "Delivered",
    Error = "Error",
}

export enum NotificationChannels {
    None = "None",
    Email = "Email",
    Sms = "Sms",
    System = "System",
    Push = "Push",
    WebPortal = "WebPortal",
}

export class DeliveryAttemptDto implements IDeliveryAttemptDto {
    attemptDateTime?: Date;
    status?: string | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IDeliveryAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptDateTime = _data["attemptDateTime"] ? new Date(_data["attemptDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): DeliveryAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptDateTime"] = this.attemptDateTime ? this.attemptDateTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }

    clone(): DeliveryAttemptDto {
        const json = this.toJSON();
        let result = new DeliveryAttemptDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryAttemptDto {
    attemptDateTime?: Date;
    status?: string | undefined;
    statusDetail?: string | undefined;
}

export class NotificationDto implements INotificationDto {
    notificationId?: number;
    receiverName?: string | undefined;
    receiverType?: string | undefined;
    creationDateTime?: Date;
    deliveredDateTime?: Date | undefined;
    receivedDateTime?: Date;
    messageData?: string | undefined;
    typeId?: number;
    status?: string | undefined;
    typeName?: string | undefined;
    notificationDeliveryId?: number | undefined;
    finalMessage?: string | undefined;
    address?: string | undefined;
    channel?: string | undefined;
    documentUUID?: string | undefined;
    detailsUrl?: string | undefined;
    notificationSubject?: string | undefined;
    metadata?: string | undefined;
    isBacthed?: boolean;
    language?: string | undefined;
    deliveryAttempts?: DeliveryAttemptDto[] | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.receiverName = _data["receiverName"];
            this.receiverType = _data["receiverType"];
            this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : <any>undefined;
            this.deliveredDateTime = _data["deliveredDateTime"] ? new Date(_data["deliveredDateTime"].toString()) : <any>undefined;
            this.receivedDateTime = _data["receivedDateTime"] ? new Date(_data["receivedDateTime"].toString()) : <any>undefined;
            this.messageData = _data["messageData"];
            this.typeId = _data["typeId"];
            this.status = _data["status"];
            this.typeName = _data["typeName"];
            this.notificationDeliveryId = _data["notificationDeliveryId"];
            this.finalMessage = _data["finalMessage"];
            this.address = _data["address"];
            this.channel = _data["channel"];
            this.documentUUID = _data["documentUUID"];
            this.detailsUrl = _data["detailsUrl"];
            this.notificationSubject = _data["notificationSubject"];
            this.metadata = _data["metadata"];
            this.isBacthed = _data["isBacthed"];
            this.language = _data["language"];
            if (Array.isArray(_data["deliveryAttempts"])) {
                this.deliveryAttempts = [] as any;
                for (let item of _data["deliveryAttempts"])
                    this.deliveryAttempts!.push(DeliveryAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["receiverName"] = this.receiverName;
        data["receiverType"] = this.receiverType;
        data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>undefined;
        data["deliveredDateTime"] = this.deliveredDateTime ? this.deliveredDateTime.toISOString() : <any>undefined;
        data["receivedDateTime"] = this.receivedDateTime ? this.receivedDateTime.toISOString() : <any>undefined;
        data["messageData"] = this.messageData;
        data["typeId"] = this.typeId;
        data["status"] = this.status;
        data["typeName"] = this.typeName;
        data["notificationDeliveryId"] = this.notificationDeliveryId;
        data["finalMessage"] = this.finalMessage;
        data["address"] = this.address;
        data["channel"] = this.channel;
        data["documentUUID"] = this.documentUUID;
        data["detailsUrl"] = this.detailsUrl;
        data["notificationSubject"] = this.notificationSubject;
        data["metadata"] = this.metadata;
        data["isBacthed"] = this.isBacthed;
        data["language"] = this.language;
        if (Array.isArray(this.deliveryAttempts)) {
            data["deliveryAttempts"] = [];
            for (let item of this.deliveryAttempts)
                data["deliveryAttempts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): NotificationDto {
        const json = this.toJSON();
        let result = new NotificationDto();
        result.init(json);
        return result;
    }
}

export interface INotificationDto {
    notificationId?: number;
    receiverName?: string | undefined;
    receiverType?: string | undefined;
    creationDateTime?: Date;
    deliveredDateTime?: Date | undefined;
    receivedDateTime?: Date;
    messageData?: string | undefined;
    typeId?: number;
    status?: string | undefined;
    typeName?: string | undefined;
    notificationDeliveryId?: number | undefined;
    finalMessage?: string | undefined;
    address?: string | undefined;
    channel?: string | undefined;
    documentUUID?: string | undefined;
    detailsUrl?: string | undefined;
    notificationSubject?: string | undefined;
    metadata?: string | undefined;
    isBacthed?: boolean;
    language?: string | undefined;
    deliveryAttempts?: DeliveryAttemptDto[] | undefined;
}

export class MetaData implements IMetaData {
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): MetaData {
        const json = this.toJSON();
        let result = new MetaData();
        result.init(json);
        return result;
    }
}

export interface IMetaData {
    totalPages?: number;
    totalCount?: number;
}

export class SearchNotificationResponse implements ISearchNotificationResponse {
    result?: NotificationDto[] | undefined;
    metadata?: MetaData;

    constructor(data?: ISearchNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(NotificationDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? MetaData.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SearchNotificationResponse {
        const json = this.toJSON();
        let result = new SearchNotificationResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchNotificationResponse {
    result?: NotificationDto[] | undefined;
    metadata?: MetaData;
}

export class ViewNotificationDetailsResponse implements IViewNotificationDetailsResponse {
    receiverTypeId?: number | undefined;
    notificationType?: string | undefined;
    notificationChannel?: string | undefined;
    notificationStatus?: string | undefined;
    notificationLanguage?: string | undefined;
    channelAddress?: string | undefined;
    creationDate?: Date;
    finalMessage?: string | undefined;
    notificationDeliveryType?: string | undefined;
    messagesCount?: number;
    deliveryDate?: Date | undefined;
    notificationDeliveryAttemptsCount?: number;
    notificationId?: number;

    constructor(data?: IViewNotificationDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverTypeId = _data["receiverTypeId"];
            this.notificationType = _data["notificationType"];
            this.notificationChannel = _data["notificationChannel"];
            this.notificationStatus = _data["notificationStatus"];
            this.notificationLanguage = _data["notificationLanguage"];
            this.channelAddress = _data["channelAddress"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.finalMessage = _data["finalMessage"];
            this.notificationDeliveryType = _data["notificationDeliveryType"];
            this.messagesCount = _data["messagesCount"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.notificationDeliveryAttemptsCount = _data["notificationDeliveryAttemptsCount"];
            this.notificationId = _data["notificationId"];
        }
    }

    static fromJS(data: any): ViewNotificationDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewNotificationDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverTypeId"] = this.receiverTypeId;
        data["notificationType"] = this.notificationType;
        data["notificationChannel"] = this.notificationChannel;
        data["notificationStatus"] = this.notificationStatus;
        data["notificationLanguage"] = this.notificationLanguage;
        data["channelAddress"] = this.channelAddress;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["finalMessage"] = this.finalMessage;
        data["notificationDeliveryType"] = this.notificationDeliveryType;
        data["messagesCount"] = this.messagesCount;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["notificationDeliveryAttemptsCount"] = this.notificationDeliveryAttemptsCount;
        data["notificationId"] = this.notificationId;
        return data; 
    }

    clone(): ViewNotificationDetailsResponse {
        const json = this.toJSON();
        let result = new ViewNotificationDetailsResponse();
        result.init(json);
        return result;
    }
}

export interface IViewNotificationDetailsResponse {
    receiverTypeId?: number | undefined;
    notificationType?: string | undefined;
    notificationChannel?: string | undefined;
    notificationStatus?: string | undefined;
    notificationLanguage?: string | undefined;
    channelAddress?: string | undefined;
    creationDate?: Date;
    finalMessage?: string | undefined;
    notificationDeliveryType?: string | undefined;
    messagesCount?: number;
    deliveryDate?: Date | undefined;
    notificationDeliveryAttemptsCount?: number;
    notificationId?: number;
}

export enum PushNotificationTypes {
    None = "None",
    User = "User",
    LinkedTaxpayers = "LinkedTaxpayers",
    UserAndLinkedTaxpayers = "UserAndLinkedTaxpayers",
}

export class PushNotificationPreferenceRequestDto implements IPushNotificationPreferenceRequestDto {
    installationId?: string | undefined;
    pushChannel?: string | undefined;
    platform?: string | undefined;
    pushNotificationTypeId?: PushNotificationTypes;

    constructor(data?: IPushNotificationPreferenceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.pushChannel = _data["pushChannel"];
            this.platform = _data["platform"];
            this.pushNotificationTypeId = _data["pushNotificationTypeId"];
        }
    }

    static fromJS(data: any): PushNotificationPreferenceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationPreferenceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["pushChannel"] = this.pushChannel;
        data["platform"] = this.platform;
        data["pushNotificationTypeId"] = this.pushNotificationTypeId;
        return data; 
    }

    clone(): PushNotificationPreferenceRequestDto {
        const json = this.toJSON();
        let result = new PushNotificationPreferenceRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPushNotificationPreferenceRequestDto {
    installationId?: string | undefined;
    pushChannel?: string | undefined;
    platform?: string | undefined;
    pushNotificationTypeId?: PushNotificationTypes;
}

export class RecipientNotificationPreferenceRequestDto implements IRecipientNotificationPreferenceRequestDto {
    id?: number;
    notificationTypeId?: NotificationTypes;
    isSubscribed?: boolean;
    isBatched?: boolean;

    constructor(data?: IRecipientNotificationPreferenceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notificationTypeId = _data["notificationTypeId"];
            this.isSubscribed = _data["isSubscribed"];
            this.isBatched = _data["isBatched"];
        }
    }

    static fromJS(data: any): RecipientNotificationPreferenceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientNotificationPreferenceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notificationTypeId"] = this.notificationTypeId;
        data["isSubscribed"] = this.isSubscribed;
        data["isBatched"] = this.isBatched;
        return data; 
    }

    clone(): RecipientNotificationPreferenceRequestDto {
        const json = this.toJSON();
        let result = new RecipientNotificationPreferenceRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRecipientNotificationPreferenceRequestDto {
    id?: number;
    notificationTypeId?: NotificationTypes;
    isSubscribed?: boolean;
    isBatched?: boolean;
}

export class RecipientPreferenceRequestDto implements IRecipientPreferenceRequestDto {
    notificationChannelId?: NotificationChannels;
    batchInterval?: number | undefined;
    pushNotificationPreference?: PushNotificationPreferenceRequestDto;
    recipientNotificationPreferences?: RecipientNotificationPreferenceRequestDto[] | undefined;

    constructor(data?: IRecipientPreferenceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationChannelId = _data["notificationChannelId"];
            this.batchInterval = _data["batchInterval"];
            this.pushNotificationPreference = _data["pushNotificationPreference"] ? PushNotificationPreferenceRequestDto.fromJS(_data["pushNotificationPreference"]) : <any>undefined;
            if (Array.isArray(_data["recipientNotificationPreferences"])) {
                this.recipientNotificationPreferences = [] as any;
                for (let item of _data["recipientNotificationPreferences"])
                    this.recipientNotificationPreferences!.push(RecipientNotificationPreferenceRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipientPreferenceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientPreferenceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationChannelId"] = this.notificationChannelId;
        data["batchInterval"] = this.batchInterval;
        data["pushNotificationPreference"] = this.pushNotificationPreference ? this.pushNotificationPreference.toJSON() : <any>undefined;
        if (Array.isArray(this.recipientNotificationPreferences)) {
            data["recipientNotificationPreferences"] = [];
            for (let item of this.recipientNotificationPreferences)
                data["recipientNotificationPreferences"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RecipientPreferenceRequestDto {
        const json = this.toJSON();
        let result = new RecipientPreferenceRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRecipientPreferenceRequestDto {
    notificationChannelId?: NotificationChannels;
    batchInterval?: number | undefined;
    pushNotificationPreference?: PushNotificationPreferenceRequestDto;
    recipientNotificationPreferences?: RecipientNotificationPreferenceRequestDto[] | undefined;
}

export enum NotificationReceipientTypes {
    None = "None",
    Organization = "Organization",
    User = "User",
    InternalUser = "InternalUser",
    Forign = "Forign",
}

export enum NotificationLanguages {
    None = "None",
    En = "En",
    Ar = "Ar",
}

export class NotificationUserChannelDto implements INotificationUserChannelDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: INotificationUserChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): NotificationUserChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data; 
    }

    clone(): NotificationUserChannelDto {
        const json = this.toJSON();
        let result = new NotificationUserChannelDto();
        result.init(json);
        return result;
    }
}

export interface INotificationUserChannelDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export class NotificationUserLanguageDto implements INotificationUserLanguageDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: INotificationUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): NotificationUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data; 
    }

    clone(): NotificationUserLanguageDto {
        const json = this.toJSON();
        let result = new NotificationUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface INotificationUserLanguageDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export class RecipientTypeDto implements IRecipientTypeDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: IRecipientTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): RecipientTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data; 
    }

    clone(): RecipientTypeDto {
        const json = this.toJSON();
        let result = new RecipientTypeDto();
        result.init(json);
        return result;
    }
}

export interface IRecipientTypeDto {
    id?: number;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export class RecipientDefaultAddressDTo implements IRecipientDefaultAddressDTo {
    id?: number;
    recipientPreferenceId?: number;
    notificationChannelId?: number;
    channelAddress?: string | undefined;

    constructor(data?: IRecipientDefaultAddressDTo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipientPreferenceId = _data["recipientPreferenceId"];
            this.notificationChannelId = _data["notificationChannelId"];
            this.channelAddress = _data["channelAddress"];
        }
    }

    static fromJS(data: any): RecipientDefaultAddressDTo {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientDefaultAddressDTo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipientPreferenceId"] = this.recipientPreferenceId;
        data["notificationChannelId"] = this.notificationChannelId;
        data["channelAddress"] = this.channelAddress;
        return data; 
    }

    clone(): RecipientDefaultAddressDTo {
        const json = this.toJSON();
        let result = new RecipientDefaultAddressDTo();
        result.init(json);
        return result;
    }
}

export interface IRecipientDefaultAddressDTo {
    id?: number;
    recipientPreferenceId?: number;
    notificationChannelId?: number;
    channelAddress?: string | undefined;
}

export enum NotificationDeliveryStatuses {
    None = "None",
    New = "New",
    Pending = "Pending",
    InProgress = "InProgress",
    Delivered = "Delivered",
    Error = "Error",
}

export class NotificationUserDeliveryDto implements INotificationUserDeliveryDto {
    id?: number;
    notificationDeliveryStatusId?: NotificationDeliveryStatuses;
    notificationLanguageId?: NotificationLanguages;
    recipientPreferenceId?: number | undefined;
    notificationChannelId?: NotificationChannels;
    channelAddress?: string | undefined;
    finalMessage?: string | undefined;
    deliveryStatusDetail?: string | undefined;
    deliveredDateTimeUtc?: Date | undefined;
    creationDateTimeUtc?: Date;
    deliveryDateTimeUtc?: Date | undefined;
    notificationTypeBatchGroupId?: number | undefined;

    constructor(data?: INotificationUserDeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notificationDeliveryStatusId = _data["notificationDeliveryStatusId"];
            this.notificationLanguageId = _data["notificationLanguageId"];
            this.recipientPreferenceId = _data["recipientPreferenceId"];
            this.notificationChannelId = _data["notificationChannelId"];
            this.channelAddress = _data["channelAddress"];
            this.finalMessage = _data["finalMessage"];
            this.deliveryStatusDetail = _data["deliveryStatusDetail"];
            this.deliveredDateTimeUtc = _data["deliveredDateTimeUtc"] ? new Date(_data["deliveredDateTimeUtc"].toString()) : <any>undefined;
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.deliveryDateTimeUtc = _data["deliveryDateTimeUtc"] ? new Date(_data["deliveryDateTimeUtc"].toString()) : <any>undefined;
            this.notificationTypeBatchGroupId = _data["notificationTypeBatchGroupId"];
        }
    }

    static fromJS(data: any): NotificationUserDeliveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserDeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notificationDeliveryStatusId"] = this.notificationDeliveryStatusId;
        data["notificationLanguageId"] = this.notificationLanguageId;
        data["recipientPreferenceId"] = this.recipientPreferenceId;
        data["notificationChannelId"] = this.notificationChannelId;
        data["channelAddress"] = this.channelAddress;
        data["finalMessage"] = this.finalMessage;
        data["deliveryStatusDetail"] = this.deliveryStatusDetail;
        data["deliveredDateTimeUtc"] = this.deliveredDateTimeUtc ? this.deliveredDateTimeUtc.toISOString() : <any>undefined;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["deliveryDateTimeUtc"] = this.deliveryDateTimeUtc ? this.deliveryDateTimeUtc.toISOString() : <any>undefined;
        data["notificationTypeBatchGroupId"] = this.notificationTypeBatchGroupId;
        return data; 
    }

    clone(): NotificationUserDeliveryDto {
        const json = this.toJSON();
        let result = new NotificationUserDeliveryDto();
        result.init(json);
        return result;
    }
}

export interface INotificationUserDeliveryDto {
    id?: number;
    notificationDeliveryStatusId?: NotificationDeliveryStatuses;
    notificationLanguageId?: NotificationLanguages;
    recipientPreferenceId?: number | undefined;
    notificationChannelId?: NotificationChannels;
    channelAddress?: string | undefined;
    finalMessage?: string | undefined;
    deliveryStatusDetail?: string | undefined;
    deliveredDateTimeUtc?: Date | undefined;
    creationDateTimeUtc?: Date;
    deliveryDateTimeUtc?: Date | undefined;
    notificationTypeBatchGroupId?: number | undefined;
}

export class RecipientNotificationPreferenceDto implements IRecipientNotificationPreferenceDto {
    id?: number;
    recipientPreferenceId?: number;
    notificationTypeId?: NotificationTypes;
    isSubscribed?: boolean;
    isBatched?: boolean;

    constructor(data?: IRecipientNotificationPreferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipientPreferenceId = _data["recipientPreferenceId"];
            this.notificationTypeId = _data["notificationTypeId"];
            this.isSubscribed = _data["isSubscribed"];
            this.isBatched = _data["isBatched"];
        }
    }

    static fromJS(data: any): RecipientNotificationPreferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientNotificationPreferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipientPreferenceId"] = this.recipientPreferenceId;
        data["notificationTypeId"] = this.notificationTypeId;
        data["isSubscribed"] = this.isSubscribed;
        data["isBatched"] = this.isBatched;
        return data; 
    }

    clone(): RecipientNotificationPreferenceDto {
        const json = this.toJSON();
        let result = new RecipientNotificationPreferenceDto();
        result.init(json);
        return result;
    }
}

export interface IRecipientNotificationPreferenceDto {
    id?: number;
    recipientPreferenceId?: number;
    notificationTypeId?: NotificationTypes;
    isSubscribed?: boolean;
    isBatched?: boolean;
}

export class PushNotificationPreferenceResponseDto implements IPushNotificationPreferenceResponseDto {
    id?: number;
    recipientPreferenceId?: number;
    userProfileId?: number;
    installationId?: string | undefined;
    pushChannel?: string | undefined;
    platform?: string | undefined;
    pushNotificationTypeId?: PushNotificationTypes;

    constructor(data?: IPushNotificationPreferenceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipientPreferenceId = _data["recipientPreferenceId"];
            this.userProfileId = _data["userProfileId"];
            this.installationId = _data["installationId"];
            this.pushChannel = _data["pushChannel"];
            this.platform = _data["platform"];
            this.pushNotificationTypeId = _data["pushNotificationTypeId"];
        }
    }

    static fromJS(data: any): PushNotificationPreferenceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationPreferenceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipientPreferenceId"] = this.recipientPreferenceId;
        data["userProfileId"] = this.userProfileId;
        data["installationId"] = this.installationId;
        data["pushChannel"] = this.pushChannel;
        data["platform"] = this.platform;
        data["pushNotificationTypeId"] = this.pushNotificationTypeId;
        return data; 
    }

    clone(): PushNotificationPreferenceResponseDto {
        const json = this.toJSON();
        let result = new PushNotificationPreferenceResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPushNotificationPreferenceResponseDto {
    id?: number;
    recipientPreferenceId?: number;
    userProfileId?: number;
    installationId?: string | undefined;
    pushChannel?: string | undefined;
    platform?: string | undefined;
    pushNotificationTypeId?: PushNotificationTypes;
}

export class RecipientUserPreferenceDto implements IRecipientUserPreferenceDto {
    id?: number;
    recipientTypeId?: NotificationReceipientTypes;
    recipientUniqueId?: string | undefined;
    recipientNamePrimaryLang?: string | undefined;
    recipientNameSecondaryLang?: string | undefined;
    notificationChannelId?: NotificationChannels;
    notificationLanguageId?: NotificationLanguages;
    batchInterval?: number | undefined;
    notificationChannel?: NotificationUserChannelDto;
    notificationLanguage?: NotificationUserLanguageDto;
    recipientType?: RecipientTypeDto;
    recipientDefaultAddresses?: RecipientDefaultAddressDTo[] | undefined;
    notificationDelivery?: NotificationUserDeliveryDto;
    recipientNotificationPreferences?: RecipientNotificationPreferenceDto[] | undefined;
    pushNotificationPreferences?: PushNotificationPreferenceResponseDto[] | undefined;

    constructor(data?: IRecipientUserPreferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipientTypeId = _data["recipientTypeId"];
            this.recipientUniqueId = _data["recipientUniqueId"];
            this.recipientNamePrimaryLang = _data["recipientNamePrimaryLang"];
            this.recipientNameSecondaryLang = _data["recipientNameSecondaryLang"];
            this.notificationChannelId = _data["notificationChannelId"];
            this.notificationLanguageId = _data["notificationLanguageId"];
            this.batchInterval = _data["batchInterval"];
            this.notificationChannel = _data["notificationChannel"] ? NotificationUserChannelDto.fromJS(_data["notificationChannel"]) : <any>undefined;
            this.notificationLanguage = _data["notificationLanguage"] ? NotificationUserLanguageDto.fromJS(_data["notificationLanguage"]) : <any>undefined;
            this.recipientType = _data["recipientType"] ? RecipientTypeDto.fromJS(_data["recipientType"]) : <any>undefined;
            if (Array.isArray(_data["recipientDefaultAddresses"])) {
                this.recipientDefaultAddresses = [] as any;
                for (let item of _data["recipientDefaultAddresses"])
                    this.recipientDefaultAddresses!.push(RecipientDefaultAddressDTo.fromJS(item));
            }
            this.notificationDelivery = _data["notificationDelivery"] ? NotificationUserDeliveryDto.fromJS(_data["notificationDelivery"]) : <any>undefined;
            if (Array.isArray(_data["recipientNotificationPreferences"])) {
                this.recipientNotificationPreferences = [] as any;
                for (let item of _data["recipientNotificationPreferences"])
                    this.recipientNotificationPreferences!.push(RecipientNotificationPreferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["pushNotificationPreferences"])) {
                this.pushNotificationPreferences = [] as any;
                for (let item of _data["pushNotificationPreferences"])
                    this.pushNotificationPreferences!.push(PushNotificationPreferenceResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipientUserPreferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientUserPreferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipientTypeId"] = this.recipientTypeId;
        data["recipientUniqueId"] = this.recipientUniqueId;
        data["recipientNamePrimaryLang"] = this.recipientNamePrimaryLang;
        data["recipientNameSecondaryLang"] = this.recipientNameSecondaryLang;
        data["notificationChannelId"] = this.notificationChannelId;
        data["notificationLanguageId"] = this.notificationLanguageId;
        data["batchInterval"] = this.batchInterval;
        data["notificationChannel"] = this.notificationChannel ? this.notificationChannel.toJSON() : <any>undefined;
        data["notificationLanguage"] = this.notificationLanguage ? this.notificationLanguage.toJSON() : <any>undefined;
        data["recipientType"] = this.recipientType ? this.recipientType.toJSON() : <any>undefined;
        if (Array.isArray(this.recipientDefaultAddresses)) {
            data["recipientDefaultAddresses"] = [];
            for (let item of this.recipientDefaultAddresses)
                data["recipientDefaultAddresses"].push(item.toJSON());
        }
        data["notificationDelivery"] = this.notificationDelivery ? this.notificationDelivery.toJSON() : <any>undefined;
        if (Array.isArray(this.recipientNotificationPreferences)) {
            data["recipientNotificationPreferences"] = [];
            for (let item of this.recipientNotificationPreferences)
                data["recipientNotificationPreferences"].push(item.toJSON());
        }
        if (Array.isArray(this.pushNotificationPreferences)) {
            data["pushNotificationPreferences"] = [];
            for (let item of this.pushNotificationPreferences)
                data["pushNotificationPreferences"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RecipientUserPreferenceDto {
        const json = this.toJSON();
        let result = new RecipientUserPreferenceDto();
        result.init(json);
        return result;
    }
}

export interface IRecipientUserPreferenceDto {
    id?: number;
    recipientTypeId?: NotificationReceipientTypes;
    recipientUniqueId?: string | undefined;
    recipientNamePrimaryLang?: string | undefined;
    recipientNameSecondaryLang?: string | undefined;
    notificationChannelId?: NotificationChannels;
    notificationLanguageId?: NotificationLanguages;
    batchInterval?: number | undefined;
    notificationChannel?: NotificationUserChannelDto;
    notificationLanguage?: NotificationUserLanguageDto;
    recipientType?: RecipientTypeDto;
    recipientDefaultAddresses?: RecipientDefaultAddressDTo[] | undefined;
    notificationDelivery?: NotificationUserDeliveryDto;
    recipientNotificationPreferences?: RecipientNotificationPreferenceDto[] | undefined;
    pushNotificationPreferences?: PushNotificationPreferenceResponseDto[] | undefined;
}

export class GetUserPreferenceResponse implements IGetUserPreferenceResponse {
    result?: RecipientUserPreferenceDto[] | undefined;

    constructor(data?: IGetUserPreferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(RecipientUserPreferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserPreferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPreferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetUserPreferenceResponse {
        const json = this.toJSON();
        let result = new GetUserPreferenceResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserPreferenceResponse {
    result?: RecipientUserPreferenceDto[] | undefined;
}

export class GetEmployeeLastCheckDateResponseDto implements IGetEmployeeLastCheckDateResponseDto {
    lastCheckDate?: Date | undefined;

    constructor(data?: IGetEmployeeLastCheckDateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastCheckDate = _data["lastCheckDate"] ? new Date(_data["lastCheckDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeLastCheckDateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeLastCheckDateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastCheckDate"] = this.lastCheckDate ? this.lastCheckDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): GetEmployeeLastCheckDateResponseDto {
        const json = this.toJSON();
        let result = new GetEmployeeLastCheckDateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetEmployeeLastCheckDateResponseDto {
    lastCheckDate?: Date | undefined;
}

export class GetSystemConfigurationResponse implements IGetSystemConfigurationResponse {
    value?: string | undefined;

    constructor(data?: IGetSystemConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetSystemConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }

    clone(): GetSystemConfigurationResponse {
        const json = this.toJSON();
        let result = new GetSystemConfigurationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSystemConfigurationResponse {
    value?: string | undefined;
}

export class ActivatePushNotificationRequestDto implements IActivatePushNotificationRequestDto {
    installationId?: string | undefined;
    pushChannel?: string | undefined;
    platform?: string | undefined;

    constructor(data?: IActivatePushNotificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.pushChannel = _data["pushChannel"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): ActivatePushNotificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivatePushNotificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["pushChannel"] = this.pushChannel;
        data["platform"] = this.platform;
        return data; 
    }

    clone(): ActivatePushNotificationRequestDto {
        const json = this.toJSON();
        let result = new ActivatePushNotificationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IActivatePushNotificationRequestDto {
    installationId?: string | undefined;
    pushChannel?: string | undefined;
    platform?: string | undefined;
}

export class DeactivatePushNotificationRequestDto implements IDeactivatePushNotificationRequestDto {
    installationId?: string | undefined;

    constructor(data?: IDeactivatePushNotificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
        }
    }

    static fromJS(data: any): DeactivatePushNotificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivatePushNotificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        return data; 
    }

    clone(): DeactivatePushNotificationRequestDto {
        const json = this.toJSON();
        let result = new DeactivatePushNotificationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDeactivatePushNotificationRequestDto {
    installationId?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}